module.exports = __webpack_public_path__ + "static/media/15_portrait.8fe4a72f.jpg";